export default "__VITE_ASSET__BxjzuUam__"